import { render } from "./sister-brothers.vue?vue&type=template&id=6ce5297a&scoped=true"
import script from "./sister-brothers.vue?vue&type=script&lang=js"
export * from "./sister-brothers.vue?vue&type=script&lang=js"

import "./sister-brothers.vue?vue&type=style&index=0&id=6ce5297a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce5297a"]])

export default __exports__